class Menu {
    constructor(passedElement) {
        this.elem = passedElement;
    }

    init() {
        // Find the menu button and menu item elements
        const menuButton = document.querySelector('[data-menu-button]');
        const menuItem = document.querySelector('[data-menu-item]');

        // Add a click event listener to the menu button
        menuButton.addEventListener("click", () => {
            // Toggle the 'nav--is-active' class on the menu item
            this.toggleClass(menuItem, 'nav--is-active');
        });
    }

    toggleClass(item, className) {
        // Check if the item has the specified class
        if (item.classList.contains(className)) {
            // If it does, remove the class
            item.classList.remove(className);
        } else {
            // If it doesn't, add the class
            item.classList.add(className);
        }
    }
}

export default Menu;




